import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router';

/** Project concept id from `/inquiries/new?conceptId=...` when promoting a concept to an inquiry. */
export function useLlmChatConceptScope(): string | null {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    if (pathname !== '/inquiries/new') return null;
    return searchParams.get('conceptId');
  }, [pathname, searchParams]);
}
